import React from 'react'
import { KeyboardAvoidingView, Platform, ScrollView, TextInput } from 'react-native'
import { SHr, SLoad, SNavigation, SNotification, SPage, SText, STheme, SView } from 'servisofts-component2'
// import { launchCamera, launchImageLibrary } from 'react-native-image-picker'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import Carga_truck from '../../Assets/carga_truck.svg';
import Item_photo_picker from './Components/Item_photo_picker';
import MDL from '../../MDL';
import HTTP from '../../HTTP';
import Config from '../../Config';

const MIN_SAVE_MODAL_MS = 1000;

export default class ChecklistImageCollection extends React.Component {
    constructor(props) {
        super(props);
        this.incidenciaUpdateTimeout = null;
        this.lastIncidenciaSent = undefined;
        this.navFocusListener = null;
        this.state = {
            photos: {},
            incidencia: '',
            isSaving: false,
            uploadCurrent: 0,
            uploadTotal: 0,
            loadingSlots: true,
            slotError: null,
            slots: [],
            missingRequired: {},
            checklist_id: '',
        };
    }

    tipo_vehiculo_id = SNavigation.getParam("tipo_vehiculo_id", "");
    async componentDidMount() {
        try {
            const checklist_id = SNavigation.getParam("id", "");
            let preguntas = await MDL.checklist.getChecklistFotos();
            preguntas = preguntas.filter(a => a.tipo_vehiculo_id == this.tipo_vehiculo_id);
            console.log("Preguntas recibidas para checklist_id", checklist_id, ":", preguntas);
            const slots = this.normalizeSlots(preguntas);
            this.setState({ slots, loadingSlots: false, slotError: null, checklist_id, });
            if (SNavigation.addListener) {
                this.navFocusListener = SNavigation.addListener('focus', () => {
                    const newChecklistId = SNavigation.getParam("id", "");
                    if (newChecklistId !== this.state.checklist_id) {
                        console.log("ChecklistImageCollection: ID actualizado de", this.state.checklist_id, "a", newChecklistId);
                        this.setState({ checklist_id: newChecklistId });
                    }
                });
            }
        } catch (error) {
            this.setState({
                loadingSlots: false,
                slotError: error?.message || String(error),
                slots: [],
            });
        }
    }

    componentWillUnmount() {
        if (this.incidenciaUpdateTimeout) {
            clearTimeout(this.incidenciaUpdateTimeout);
            this.incidenciaUpdateTimeout = null;
        }
        if (this.navFocusListener) {
            this.navFocusListener();
            this.navFocusListener = null;
        }
    }

    normalizeSlots(items) {
        if (!Array.isArray(items)) return [];
        return items.map((item, index) => {
            const key = String(item?.id ?? item?.key ?? `photo-${index}`);
            const rawText = String(item?.pregunta ?? item?.descripcion ?? `Subir foto ${index + 1}`);
            const cleanedLabel = rawText
                .replace(/^subir\s+foto\s*/i, '')
                .replace(/^foto\s*/i, '')
                .trim();
            const label = (cleanedLabel || rawText).toUpperCase();
            return { key, label, text: rawText, required: Number(item?.requerido ?? item?.required ?? 0) === 1, };
        });
    }

    getSelectedPhotoEntries() {
        return Object.entries(this.state.photos).filter(([, file]) => !!file?.uri);
    }

    getMissingRequiredMap() {
        const missingRequired = {};
        const slots = Array.isArray(this.state.slots) ? this.state.slots : [];
        const photos = this.state.photos || {};
        slots.forEach((slot) => {
            if (!slot?.required) return;
            const hasPhoto = !!photos?.[slot.key]?.uri;
            if (!hasPhoto) {
                missingRequired[slot.key] = true;
            }
        });
        return missingRequired;
    }

    getPhotoFileName(file) {
        const directName = String(file?.name || '').trim();
        if (directName) return directName;
        const raw = String(file?.uri || '');
        const withoutQuery = raw.split('?')[0];
        const fileName = withoutQuery.split(/[\\/]/).pop() || withoutQuery;
        try {
            return decodeURIComponent(fileName);
        } catch {
            return fileName;
        }
    }

    async logAllData() {
        const checklist_id = this.state.checklist_id;
        if (!checklist_id) {
            console.warn("No se recibio checklist_id desde la pantalla anterior.");
            return [];
        }
        const selectedPhotos = this.getSelectedPhotoEntries();
        const respuestas = [];
        for (let i = 0; i < selectedPhotos.length; i++) {
            const [checklist_pregunta_id, file] = selectedPhotos[i];
            const uploadResponse = await MDL.checklist.postChecklistFoto({
                checklist_id: String(checklist_id),
                checklist_pregunta_id: String(checklist_pregunta_id),
                file,
            });
            const respuestaFileName = String(this.getPhotoFileName(file)).trim();
            const urlPath = String(uploadResponse?.path || '').trim();
            if (!respuestaFileName) continue;
            respuestas.push({ checklist_id, checklist_pregunta_id: String(checklist_pregunta_id), respuesta: respuestaFileName, url_path: urlPath, });
        }
        if (respuestas.length <= 0) {
            return [];
        }
        const postResponse = await Promise.all(
            respuestas.map((body) => MDL.checklist.postChecklistDetalle(body))
        );
        return postResponse;
    }

    simulateUploadSlot() {
        return new Promise((resolve) => {
            setTimeout(resolve, 420);
        });
    }

    handleIncidenciaChange = (text) => {
        this.setState({ incidencia: text });
        this.scheduleIncidenciaUpdate(text);
    }

    scheduleIncidenciaUpdate = (mensaje) => {
        if (this.incidenciaUpdateTimeout) {
            clearTimeout(this.incidenciaUpdateTimeout);
            this.incidenciaUpdateTimeout = null;
        }
        this.incidenciaUpdateTimeout = setTimeout(() => {
            this.updateIncidenciaOnServer(mensaje);
        }, 600);
    }

    updateIncidenciaOnServer = async (incidencia, options) => {
        try {
            const checklist_id = this.state.checklist_id;
            if (!checklist_id || !incidencia) {
                console.warn("No se recibió checklist_id o incidencia");
                return;
            }

            const apiUrl = Config.apis.api_checklist;
            // const numeroooo = "66";
            const response = await HTTP.PUT({
                url: `${apiUrl}/checklist/test_simple/${checklist_id}/${incidencia}`,
                body: {}
            });

            console.log("Incidencia actualizada en servidor:", response);
            this.lastIncidenciaSent = incidencia;
            return response;
        } catch (error) {
            console.error("Error al actualizar incidencia en servidor", error);
        }
    };

    flushIncidenciaUpdate = async () => {
        if (this.incidenciaUpdateTimeout) {
            clearTimeout(this.incidenciaUpdateTimeout);
            this.incidenciaUpdateTimeout = null;
        }
        await this.updateIncidenciaOnServer(this.state.incidencia, { force: true });
    }

    async handleAccept() {
        const { isSaving } = this.state;
        if (isSaving) return;


        const checklist_id = this.state.checklist_id;
        if (!checklist_id) {
            console.warn("No se recibió checklist_id o incidencia");
            return;
        }

        const apiUrl = Config.apis.api_checklist;
        const numeroooo = "1";
        // const response = await HTTP.PUT({ url: `${apiUrl}/checklist/test_simple2/${checklist_id}/${numeroooo}`, body: {} });

        await this.flushIncidenciaUpdate();
        const missingRequired = this.getMissingRequiredMap();
        const missingRequiredCount = Object.keys(missingRequired).length;
        if (missingRequiredCount > 0) {
            this.setState({ missingRequired });
            SNotification.send({
                key: 'checklist_required_photo_missing',
                title: 'Foto requerida',
                body: 'Se requiere subir foto para finalizar.',
                color: STheme.color.danger,
                time: 3500,
            });
            return;
        }

        const saveStartMs = Date.now();
        const selectedPhotos = this.getSelectedPhotoEntries();
        const uploadTotal = selectedPhotos.length;
        if (uploadTotal <= 0) {
            try {
                await this.logAllData();
                SNotification.send({
                    key: 'checklist_finish_no_images',
                    title: 'Checklist finalizado',
                    body: 'Proceso completado correctamente.',
                    color: STheme.color.success,
                    time: 3000,
                });
            } catch (error) {
                console.error('Error al finalizar checklist sin fotos', error);
                SNotification.send({
                    key: 'checklist_finish_no_images_error',
                    title: 'No se pudo finalizar',
                    body: 'Intenta nuevamente.',
                    color: STheme.color.danger,
                    time: 3000,
                });
            }
            return;
        }

        this.setState({ isSaving: true, uploadCurrent: 0, uploadTotal, missingRequired: {}, });
        for (let i = 0; i < selectedPhotos.length; i++) {
            await this.simulateUploadSlot();
            this.setState({ uploadCurrent: i + 1 });
        }

        const elapsedMs = Date.now() - saveStartMs;
        const remainingMs = Math.max(0, MIN_SAVE_MODAL_MS - elapsedMs);
        if (remainingMs > 0) {
            await new Promise((resolve) => setTimeout(resolve, remainingMs));
        }

        try {
            await this.logAllData();
            SNotification.send({
                key: 'checklist_finish_ok',
                title: 'Checklist finalizado',
                body: 'Fotos registradas correctamente.',
                color: STheme.color.success,
                time: 3000,
            });
            await new Promise((resolve) => setTimeout(resolve, 2000));
            this.setState({
                isSaving: false,
                photos: {},
                incidencia: '',
                uploadCurrent: 0,
                uploadTotal: 0,
            });
            SNavigation.navigate('/');
            return;
        } catch (error) {
            console.error("Error al registrar checklist foto", error);
            SNotification.send({
                key: 'checklist_finish_error',
                title: 'No se pudo finalizar',
                body: 'Verifica tu conexion e intenta nuevamente.',
                color: STheme.color.danger,
                time: 3000,
            });
        }
        this.setState({ isSaving: false });
    }

    render() {
        const { photos, incidencia, isSaving, uploadCurrent, uploadTotal, slots, loadingSlots, slotError, missingRequired } = this.state;
        const progress = uploadTotal > 0 ? Math.min(1, uploadCurrent / uploadTotal) : 0;
        return (
            <SPage disableScroll>
                <KeyboardAvoidingView
                    style={{ flex: 1 }}
                    behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
                    keyboardVerticalOffset={Platform.OS === 'ios' ? 12 : 0} >
                    <Container flex>
                        <SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16 }}>
                            <SView col={"xs-12"} center>
                                <SView col={"xs-12"} center style={{ alignItems: "center" }} row>
                                    <Verified_icon width={18} height={18} fill={STheme.color.danger} style={{ marginRight: 8 }} />
                                    <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}>TIEMPO DE CHECKLIST</SText>
                                </SView>
                                <SHr height={8} />
                                <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                                <SHr height={8} />
                                <SText font='AlbertSans' bold center fontSize={22} color={STheme.color.text}>Insertar Fotografías</SText>
                                <SHr height={8} />
                            </SView>
                            <SView col={"xs-11"} flex style={{ minHeight: 0, alignSelf: 'center' }} center >
                                <ScrollView
                                    style={{ flex: 1, width: '100%' }}
                                    contentContainerStyle={{ paddingBottom: 8, alignItems: 'center' }}
                                    keyboardShouldPersistTaps="handled"
                                    showsVerticalScrollIndicator
                                >
                                    {loadingSlots ? (
                                        <SView col={"xs-12"} center>
                                            <SLoad color={STheme.color.secondary} />
                                            <SHr height={8} />
                                            <SText font='AlbertSans' center color={STheme.color.text}>Cargando fotos...</SText>
                                            <SHr height={10} />
                                        </SView>
                                    ) : null}
                                    {slotError ? (
                                        <SView col={"xs-12"} center>
                                            <SText font='AlbertSans' center color={STheme.color.danger}>{slotError}</SText>
                                            <SHr height={10} />
                                        </SView>
                                    ) : null}
                                    <SView col={"xs-12"} row style={{ flexWrap: 'wrap', justifyContent: 'space-between' }}>
                                        {(Array.isArray(slots) ? slots : []).map((slot, index) => (
                                            <SView key={`${slot.key}-${index}`}>
                                                <Item_photo_picker
                                                    label={slot.label}
                                                    text={slot.text}
                                                    required={slot.required}
                                                    highlightRequired={!!missingRequired?.[slot.key]}
                                                    uri={photos[slot.key]?.uri}
                                                    disabled={isSaving || loadingSlots}
                                                    onChange={(file) => {
                                                        if (isSaving) return;
                                                        if (loadingSlots) return;
                                                        this.setState((prev) => {
                                                            const nextMissingRequired = { ...(prev.missingRequired || {}) };
                                                            delete nextMissingRequired[slot.key];
                                                            return {
                                                                photos: { ...prev.photos, [slot.key]: file },
                                                                missingRequired: nextMissingRequired,
                                                            };
                                                        });
                                                    }}
                                                />
                                            </SView>
                                        ))}
                                    </SView>
                                </ScrollView>
                            </SView>
                            <SHr height={2} />
                            <TextInput
                                multiline
                                numberOfLines={1}
                                placeholder="Incidencia"
                                placeholderTextColor={STheme.color.lightGray}
                                value={incidencia}
                                onChangeText={this.handleIncidenciaChange}
                                onBlur={this.flushIncidenciaUpdate}
                                style={{
                                    width: '100%', minHeight: 70,
                                    borderRadius: 4, borderWidth: 1, borderColor: STheme.color.secondary,
                                    backgroundColor: STheme.color.card, color: STheme.color.text, padding: 8, fontSize: 14, textAlignVertical: 'top', outlineWidth: 0, outlineStyle: "none",
                                }}
                            />
                            <SHr height={14} />
                            <SView col={"xs-12"} row style={{ justifyContent: "space-between" }}>
                                <SView flex height={50} center style={{ borderRadius: 8, backgroundColor: STheme.color.secondary }}
                                    onPress={this.handleAccept.bind(this)}>
                                    <SText font='AlbertSans' bold color={STheme.color.primary} fontSize={20}>ACEPTAR</SText>
                                </SView>
                                <SView width={16} />
                                <SView flex height={50} center style={{ borderRadius: 8, backgroundColor: STheme.color.primary }}
                                    onPress={() => {
                                        if (isSaving) return;
                                        this.setState({
                                            photos: {},
                                            incidencia: '',
                                        });
                                        SNavigation.navigate('/');
                                    }}>
                                    <SText font='AlbertSans' color={STheme.color.text} fontSize={20} >CANCELAR</SText>
                                </SView>
                            </SView>
                        </SView>
                    </Container>
                </KeyboardAvoidingView>
                {isSaving ? (
                    <SView col={"xs-12"} center style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 9999, padding: 22, }} >
                        <SView col={"xs-11"} center style={{ maxWidth: 360, borderRadius: 16, backgroundColor: STheme.color.primary, padding: 22, }} >
                            <SView center style={{ width: 84, height: 84, borderRadius: 42, backgroundColor: STheme.color.secondary + '22', }} >
                                <Carga_truck width={48} height={32} fill={STheme.color.secondary} />
                            </SView>
                            <SHr height={14} />
                            <SText font='AlbertSans' bold center fontSize={20} color={STheme.color.text}> Guardando coleccion de fotos </SText>
                            <SHr height={6} />
                            <SText font='AlbertSans' center fontSize={16} color={STheme.color.secondary}> Subiendo al servidor </SText>
                            <SHr height={10} />
                            <SText font='AlbertSans' center fontSize={15} color={STheme.color.text}> Subiendo {uploadCurrent} / {uploadTotal} </SText>
                            <SHr height={10} />
                            <SView style={{ width: '100%', height: 10, borderRadius: 8, backgroundColor: STheme.color.lightGray, overflow: 'hidden', }} >
                                <SView style={{ width: `${Math.round(progress * 100)}%`, height: '100%', backgroundColor: STheme.color.secondary, }} />
                            </SView>
                            <SHr height={12} />
                            <SLoad color={STheme.color.secondary} />
                            <SHr height={8} />
                            <SText font='AlbertSans' center fontSize={14} color={STheme.color.text}> Por favor espere... </SText>
                        </SView>
                    </SView>
                ) : null}
                <SHr height={10} />
            </SPage>
        );
    }
}